export default __webpack_public_path__ + "static/AGaramondPro-SemiboldItalic-818a6ffb93081b9c81407843d0850940.otf";